import axios from "axios";

export type WikiSource = "wikivoyage" | "wikipedia";

const getBaseUrl = (source: WikiSource) =>
  source === "wikipedia"
    ? "https://en.wikipedia.org"
    : "https://en.wikivoyage.org";

const getApiUrl = (source: WikiSource) => `${getBaseUrl(source)}/w/api.php`;

const getPage = async (
  wikipageName: string,
  source: WikiSource = "wikivoyage"
) => {

  const params =
    "?action=parse" +
    "&format=json" +
    "&origin=*" +
    "&prop=text" +
    "&page=" + wikipageName;

  const response = await axios({
    withCredentials: false,
    url: getApiUrl(source) + params,
    // url: "https://en.wikipedia.org/w/api.php?action=opensearch&search=testing&origin=*&callback=",
    //url: "https://en.wikivoyage.org/w/api.php?action=opensearch&search=bangkok&origin=*&callback=",
  });


  return response.data;

}


const getPageSections = async (
  text: string,
  source: WikiSource = "wikivoyage"
) => {
  const params =
    "?action=parse" +
    "&format=json" +
    "&origin=*" +
    "&prop=sections" +
    "&page=" + text;

  const response = await axios({
    withCredentials: false,
    url: getApiUrl(source) + params,
    // url: "https://en.wikipedia.org/w/api.php?action=opensearch&search=testing&origin=*&callback=",
    //url: "https://en.wikivoyage.org/w/api.php?action=opensearch&search=bangkok&origin=*&callback=",
  });

  return response.data;
}

const getPageSectionText = async (
  text: string,
  section: number,
  source: WikiSource = "wikivoyage"
) => {
  const params =
    "?action=parse" +
    "&format=json" +
    "&origin=*" +
    "&prop=text" +
    "&section=" + section +
    "&disabletoc=1" +
    "&page=" + text;

  const response = await axios({
    withCredentials: false,
    url: getApiUrl(source) + params,
    // url: "https://en.wikipedia.org/w/api.php?action=opensearch&search=testing&origin=*&callback=",
    //url: "https://en.wikivoyage.org/w/api.php?action=opensearch&search=bangkok&origin=*&callback=",
  });

  return response.data;
}

const wikiQuery = async (
  text: string,
  source: WikiSource = "wikivoyage"
) => {
  // const wikiParams =
  // "?action=parse" +
  // "&format=json" +
  // "&origin=*" +
  // // "&explaintext=true" +
  // "&prop=subtitle" +
  // "&page=" +
  // text;

  // "&pageid=" +
  // pageId;

  const wikiParams =
    "?action=query" +
    "&format=json" +
    "&origin=*" +
    // "&explaintext=true" +
    "&prop=extracts" +
    "&exintro=1" +
    "&titles=" +
    text;

  const response = await axios({
    withCredentials: false,
    url: getApiUrl(source) + wikiParams,
    // url: "https://en.wikipedia.org/w/api.php?action=opensearch&search=testing&origin=*&callback=",
    //url: "https://en.wikivoyage.org/w/api.php?action=opensearch&search=bangkok&origin=*&callback=",
  });

  return response.data;
};

const wikiQueryByPageId = async (
  pageId: number,
  source: WikiSource = "wikivoyage"
) => {

  const wikiParams =
    "?action=query" +
    "&format=json" +
    "&origin=*" +
    // "&explaintext=true" +
    "&prop=extracts" +
    "&exintro=1" +
    "&pageids=" +
    pageId;

  const response = await axios({
    withCredentials: false,
    url: getApiUrl(source) + wikiParams,
    // url: "https://en.wikipedia.org/w/api.php?action=opensearch&search=testing&origin=*&callback=",
    //url: "https://en.wikivoyage.org/w/api.php?action=opensearch&search=bangkok&origin=*&callback=",
  });

  return response.data;
};


export {
  wikiQuery,
  wikiQueryByPageId,
  getPageSections,
  getPageSectionText,
  getPage,
  getBaseUrl,
};
